function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import UserAccessPermission from '@/views/tableau/UserAccessPermission';
import tasks from '@/js/tasks';
export default {
  name: 'UserAccessObjects',
  props: {
    record: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  components: {
    UserAccessPermission: UserAccessPermission
  },
  data: function data() {
    return {
      modalUserAccessPermission: 'modalUserAccessPermission',
      permissions: [],
      show: false,
      filterDataset: '',
      filterReport: '',
      filterApp: '',
      filterWorkspace: '',
      currentViewPageDataset: 1,
      currentViewPageReport: 1,
      currentViewPageApp: 1,
      currentViewPageWorkspace: 1,
      perPage: 7,
      workspace_selected: {},
      busy: false
    };
  },
  computed: {
    fieldsTableau: function fieldsTableau() {
      return [{
        value: 'name',
        text: this.traductor('tablas.name'),
        sortable: true
      }, {
        value: 'workspace_name',
        text: 'Workspace',
        sortable: true
      }, {
        value: 'access_right',
        text: this.traductor('frases.permission'),
        sortable: true
      }];
    },
    fieldsWorkspace: function fieldsWorkspace() {
      return [{
        value: 'name',
        text: this.traductor('tablas.name'),
        sortable: true
      }, {
        value: 'description',
        text: this.traductor('tablas.description'),
        sortable: true
      }, {
        value: 'capacity',
        text: this.traductor('tablas.capacity'),
        sortable: true
      }, {
        value: 'access_right',
        text: this.traductor('tablas.rol'),
        sortable: true
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        sortable: false
      }];
    },
    fieldsApps: function fieldsApps() {
      return [{
        value: 'name',
        text: this.traductor('tablas.name'),
        sortable: true
      }, {
        value: 'description',
        text: this.traductor('tablas.description'),
        sortable: true
      }, {
        value: 'access_right',
        text: this.traductor('tablas.rol'),
        sortable: true
      }];
    },
    texts: function texts() {
      return {
        user: this.traductor('tablas.user'),
        name: this.traductor('tablas.name'),
        report: this.traductor('tablas.report'),
        app: this.traductor('tablas.name'),
        search: this.traductor('frases.search_datasource'),
        no_records: this.traductor('frases.no_records')
      };
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    viewPermission: function viewPermission(item, tableauType) {
      var _iterator = _createForOfIteratorHelper(this.record[tableauType].filter(function (r) {
          return r.id !== item.id;
        })),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var record = _step.value;
          this.$root.$emit('bv::hide::popover', "'popover-button-sync-' + ".concat(record.id));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    onClose: function onClose(item) {
      this.$root.$emit('bv::hide::popover', "'popover-button-sync-' + ".concat(item.id));
    },
    deletePermission: function deletePermission() {
      var _this = this;
      console.log(this.workspace_selected.workspace_id, this.record.email);
      var data = {
        "workspace_id": this.workspace_selected.workspace_id,
        "email": this.record.email
      };
      BiReportService.deletePermissionWorkspace(data).then(function (response) {
        _this.workspace_selected = {};
        _this.busy = false;
        if (response.code == 200 && response.success) {
          tasks.toast.success("Successful request!");
          //this.$toast.success("Successful request!")
        } else {
          tasks.toast.error("Ocurrió un error, inténtelo nuevamente.");
          //this.$toast.warning("Tray again!")
        }
      }, function (err) {
        _this.busy = false;
        _this.workspace_selected = {};
      });
    },
    onConfirmRequest: function onConfirmRequest(item) {
      console.log(item);
      this.workspace_selected = item;
      this.processing = false;
      this.busy = true;
    },
    onCancelRequest: function onCancelRequest() {
      this.workspace_selected = {};
      this.busy = false;
    }
  }
};